<p-toast></p-toast>

<p-sidebar [(visible)]="isVisibleBroadcastMessageFilter"
           [position]="'right'"
           [baseZIndex]="11000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">

    <ng-template pTemplate="header">
        <div class="flex flex-row">
            <div class="verification-head">
                <div class="verification-head__title">Filter</div>
            </div>
        </div>
    </ng-template>

    <p-scrollPanel [style]="{height: 'calc(100vh - 160px)'}">
        <div class="mt-4">
            <div class="filter-label">
                Channel Type
            </div>
            <div class="field-checkbox mt-3">
                <p-checkbox name="group1" [value]="broadcastChannelType.SMS" [(ngModel)]="broadcastChannelTypes" inputId="broadcastChannelType.SMS"></p-checkbox>
                <label for="broadcastChannelType.SMS">SMS</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group1" [value]="broadcastChannelType.PushNotification" [(ngModel)]="broadcastChannelTypes" inputId="broadcastChannelType.PushNotification"></p-checkbox>
                <label for="broadcastChannelType.PushNotification">Push Notification</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group1" [value]="broadcastChannelType.Email" [(ngModel)]="broadcastChannelTypes" inputId="broadcastChannelType.Email"></p-checkbox>
                <label for="broadcastChannelType.Email">Email</label>
            </div>
        </div>

        <div class="mt-4">
            <div class="flex flex-column w-20rem">
                <label for="dateformat" class="filter-label">Date and Time</label>
                <p-calendar [(ngModel)]="dateAndTime" [showTime]="false" inputId="dateformat" placeholder="Select date"></p-calendar>
            </div>
        </div>
    </p-scrollPanel>

    <div class="flex justify-content-end mrg-10-0px">
        <button pButton pRipple type="button" label="Clear" class="outlined-white-btn padding-btn mr-3"
                (click)="clearFilter()"></button>
        <button pButton pRipple type="button" label="Done" class="bluedark-btn-filter padding-btn"
                (click)="doneFilter()"></button>
    </div>

</p-sidebar>
